import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import authReducer from "./slices/authSlices";
import jobReducer from "./slices/jobPostSlice";
import Blog from "./slices/blogSlices";
import queriesReducer from "./slices/querySlices";
import newsLetterReducer from "./slices/newsLetterSlice";
import caseStudyReducer from "./slices/caseStudySlices";
import MetaDataReducer from "./slices/metaDataSclice";
import careerReducer from "./slices/careerSlice";
import contactReducer from "./slices/contactSlice"

const reducer = combineReducers({
  authState: authReducer,
  jobState: jobReducer,
  blog: Blog,
  querieState: queriesReducer,
  newsLetterState: newsLetterReducer,
  caseStudyState: caseStudyReducer,
  metaDataState: MetaDataReducer,
  careerState: careerReducer,
  contactState: contactReducer
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export default store;
